import { z } from "zod";
export const LaborCostEntrySchema = z
    .object({
    no: z.string(),
    name: z.string(),
    type: z.string(),
    occupation: z.string(),
    manPerDay: z.coerce.number(),
    manPerHour: z.coerce.number(),
    surchargeRatio: z.coerce.number(),
    adjustmentRatio: z.coerce.number(),
    unitPrice: z.coerce.number(),
    quantity: z.coerce.number(),
    totalAmount: z.coerce.number(),
    noTotalAmount: z.coerce.number(),
})
    .strict();
